/* Flocage realiste du nom + numero sur la photo du maillot vierge (fiche produit).
   Sorti de sections/product-bluelock.liquid le 21/10/2026 (limite Shopify de 256 Ko par fichier).
   Appele par le script "Personnalisation" de la section : window.BLFlock(env) -> { draw() }.
   draw() rend l'apercu photo et renvoie true, ou renvoie false (photo non calee : l'ancien apercu prend le relais). */
window.BLFlock = function(env){
  var block = env.block, toggle = env.toggle, nameInput = env.nameInput, numberInput = env.numberInput;
  var canvas = env.canvas, isJersey = env.isJersey, isBlank = env.isBlank, blankBox = env.blankBox;
  // ====== Flocage sur la vraie photo (21/10/2026, v3 calee sur les photos officielles) ======
  // Chaque photo "vierge" (variante Customized) a son flocage officiel : position, hauteur des lettres,
  // couleur et police mesurees en comparant la photo vierge a la photo d'un joueur du meme maillot.
  // Valeurs en fraction de l'image carree. name/num/front : y = centre, h = hauteur des capitales.
  // nf / mf = police du nom / du numero. outline = numero en contour seul. stroke = liseré autour des lettres.
  // Une nouvelle photo vierge sans entree ici garde l'ancien apercu (voir memoire apercu-flocage-sur-photo).
  var FLOCK = {
    'fc-barcha-blank':           {x:.7183, w:.30, fill:'#c99d1c', nf:['Oswald',400], mf:['Oswald',400], name:{y:.5367,h:.05},  num:{y:.6844,h:.155}},
    'maillot-france-u20-custom': {x:.715,  w:.30, fill:'#e3b54a', nf:['Oswald',600], mf:['Playfair Display',700], name:{y:.455,h:.036}, num:{y:.615,h:.13}, front:{x:.31,y:.33,h:.085}},
    'blue-lock-white-blank':     {x:.6972, w:.30, fill:'#1b1e3d', nf:['Teko',600], mf:['Teko',500], name:{y:.5439,h:.046}, num:{y:.72,h:.155,outline:true}, front:{x:.3072,y:.3994,h:.165}},
    'japan-eleven-blank':        {x:.6939, w:.29, fill:'#1d2149', nf:['Teko',500], mf:['Teko',500], name:{y:.2483,h:.044}, num:{y:.39,h:.138}, front:{x:.3078,y:.5667,h:.19}},
    'bastard-munchen-custom':    {x:.6967, w:.32, nw:.18, fill:'#a48b52', nf:['Teko',600], mf:['Teko',500], name:{y:.1756,h:.048}, num:{y:.3278,h:.15}},
    'kaiser-re-ai-blank':        {x:.7258, w:.30, fill:'#3a929a', nf:['Teko',600], mf:['Teko',500], name:{y:.4811,h:.06},  num:{y:.6494,h:.142}},
    'manshine-city-blank':       {x:.6928, w:.30, fill:'#2e5e86', nf:['Oswald',400], mf:['Oswald',300], name:{y:.3111,h:.046}, num:{y:.4483,h:.14}},
    'fc-ubers-blank':            {x:.7095, w:.30, fill:'#0f110d', stroke:'#ffffff', nf:['Oswald',600], mf:['Oswald',700], name:{y:.5089,h:.044}, num:{y:.6056,h:.11}},
    'japon-u20-blank':           {x:.7147, w:.28, fill:'#7f1a1d', nf:['Teko',600], mf:['Teko',600], name:{y:.50,h:.045},  num:{y:.64,h:.15}, front:{x:.325,y:.385,h:.145}},
    'pxg-blank':                 {x:.703,  w:.30, fill:'#d4d4d2', nf:['Oswald',600], mf:['Playfair Display',600], name:{y:.3506,h:.052}, num:{y:.485,h:.15}},
    'short-france-u20-vierge':   {x:.5394, w:.16, fill:'#f6f6f6', nf:null, mf:['Playfair Display',700], name:null, num:{y:.665,h:.078}},
    'maillot-angleterre-u20-vierge': {x:.715, w:.29, fill:'#1b2453', nf:['Oswald',600], mf:['Oswald',600], name:{y:.476,h:.047}, num:{y:.615,h:.175}, front:{x:.315,y:.325,h:.113}},
    // Shorts (21/10) : photo vierge = photo joueur au numero efface. Le numero officiel est cale sur un bord
    // (al:'r' = x est le bord droit, al:'l' = le bord gauche), comme sur les photos des joueurs.
    'short-bastard-munchen-vierge': {x:.546, w:.085, fill:'#d0b577', nf:null, mf:['Teko',500], name:null, num:{y:.646,h:.051,al:'r'}},
    'short-eleven-japon-vierge':    {x:.545, w:.08,  fill:'#e9ecee', nf:null, mf:['Teko',500], name:null, num:{y:.64,h:.051,al:'r'}},
    'short-japon-u20-vierge':       {x:.544, w:.08,  fill:'#920e10', nf:null, mf:['Teko',600], name:null, num:{y:.629,h:.05,al:'r'}},
    'short-manshine-city-vierge':   {x:.545, w:.085, fill:'#17b7c5', nf:null, mf:['Teko',600], name:null, num:{y:.651,h:.052,al:'r'}},
    'short-pxg-vierge':             {x:.158, w:.09,  fill:'#dbe4ec', nf:null, mf:['Playfair Display',600], name:null, num:{y:.643,h:.063,al:'l'}},
    'short-fc-barcha-vierge':       {x:.1743, w:.08, fill:'#e2ab25', nf:null, mf:['Oswald',600], name:null, num:{y:.635,h:.052,al:'l'}}
  };
  // Dos detoure pour le cadre Apercu : zone [x0, y0, x1, y1] de la photo vierge couverte par
  // assets/bl-dos-<cle>.jpg (fabrique le 21/10 : detourage BiRefNet, manche gauche cachee = miroir de la droite).
  var DOS = {
    'fc-barcha-blank': [.4433,.3411,.9933,.9933], 'maillot-angleterre-u20-vierge': [.44,.3333,.99,.9678],
    'maillot-france-u20-custom': [.44,.3044,.99,.9489], 'blue-lock-white-blank': [.4222,.3422,.9722,.9933],
    'japan-eleven-blank': [.4389,.1022,.9489,.6922], 'bastard-munchen-custom': [.4211,.0289,.9722,.6833],
    'kaiser-re-ai-blank': [.45,.3144,1,.9922], 'manshine-city-blank': [.4178,.1833,.9678,.78],
    'fc-ubers-blank': [.4433,.3278,.9756,.9589], 'japon-u20-blank': [.4389,.3256,.99,.9156],
    'pxg-blank': [.4567,.1867,.9489,.7733], 'short-france-u20-vierge': [.0233,.2544,.55,.7967],
    'short-bastard-munchen-vierge': [.2844,.27,.7644,.75], 'short-eleven-japon-vierge': [.2844,.27,.7644,.75],
    'short-japon-u20-vierge': [.2844,.27,.7644,.75], 'short-manshine-city-vierge': [.2844,.27,.7644,.75],
    'short-pxg-vierge': [0,.27,.48,.75], 'short-fc-barcha-vierge': [0,.27,.48,.75]
  };
  var dosImg = null;
  var FONTS_CSS ='https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;600;700&family=Playfair+Display:wght@600;700&family=Teko:wght@500;600&display=swap';
  function flockKey(src){
    if(!src) return null;
    var file = String(src).split('?')[0].split('/').pop();
    for(var k in FLOCK){ if(file.indexOf(k) === 0) return k; }
    return null;
  }
  var flockSrc = null, flockCfg = null, flockKeyName = null;
  (function(){
    var imgs = document.querySelectorAll('.product-bl__image');
    for(var i = 0; i < imgs.length; i++){
      var s = imgs[i].getAttribute('src'), k = flockKey(s);
      if(k){ flockSrc = s; flockCfg = FLOCK[k]; flockKeyName = k; return; }
    }
  })();
  var hasName = !!(flockCfg && flockCfg.name && isJersey && nameInput);
  function flockTexts(){
    var n = nameInput ? nameInput.value : '';
    var num = numberInput ? numberInput.value : '';
    return {
      name: n || (nameInput ? nameInput.placeholder : ''), nameGhost: !n,
      num: num || (numberInput ? numberInput.placeholder : ''), numGhost: !num
    };
  }
  function hexRgb(h){ h = h.replace('#',''); return [parseInt(h.substr(0,2),16), parseInt(h.substr(2,2),16), parseInt(h.substr(4,2),16)]; }
  function fontStr(spec, px){ return spec[1] + ' ' + px + 'px "' + spec[0] + '", "Arial Narrow", Impact, sans-serif'; }
  // Flou rapide (3 passes de boite ~ gaussien de sigma r)
  function blur(src, w, h, r){
    r = Math.max(1, Math.round(r));
    var a = new Float32Array(src), b = new Float32Array(w * h), p, x, y, acc, n = 2 * r + 1;
    for(p = 0; p < 3; p++){
      for(y = 0; y < h; y++){
        var row = y * w; acc = 0;
        for(x = -r; x <= r; x++){ acc += a[row + Math.min(w - 1, Math.max(0, x))]; }
        for(x = 0; x < w; x++){
          b[row + x] = acc / n;
          acc += a[row + Math.min(w - 1, x + r + 1)] - a[row + Math.max(0, x - r)];
        }
      }
      for(x = 0; x < w; x++){
        acc = 0;
        for(y = -r; y <= r; y++){ acc += b[Math.min(h - 1, Math.max(0, y)) * w + x]; }
        for(y = 0; y < h; y++){
          a[y * w + x] = acc / n;
          acc += b[Math.min(h - 1, y + r + 1) * w + x] - b[Math.max(0, y - r) * w + x];
        }
      }
    }
    return a;
  }

  // Preparation (une fois par photo) : cartes des plis (deplacement), de l'ombre et du grain du tissu
  var FX = null, flockImg = null;
  function prepFX(){
    var im = flockImg, S = im.naturalWidth, H = im.naturalHeight;
    var cv = document.createElement('canvas'); cv.width = S; cv.height = H;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(im, 0, 0);
    var px;
    try { px = cx.getImageData(0, 0, S, H).data; } catch(e){ return null; } // CORS refuse : ancien apercu
    var n = S * H, lum = new Float32Array(n), i, x, y;
    for(i = 0; i < n; i++){ lum[i] = 0.299 * px[i*4] + 0.587 * px[i*4+1] + 0.114 * px[i*4+2]; }
    var big = blur(lum, S, H, S / 120), med = blur(lum, S, H, S / 150), small = blur(lum, S, H, 2);
    var gx = new Float32Array(n), gy = new Float32Array(n), fine = new Float32Array(n);
    for(y = 0; y < H; y++){
      for(x = 0; x < S; x++){
        i = y * S + x;
        gx[i] = Math.max(-1.5, Math.min(1.5, (big[y * S + Math.min(S - 1, x + 1)] - big[y * S + Math.max(0, x - 1)]) / 2));
        gy[i] = Math.max(-1.5, Math.min(1.5, (big[Math.min(H - 1, y + 1) * S + x] - big[Math.max(0, y - 1) * S + x]) / 2));
        fine[i] = lum[i] - small[i];
      }
    }
    var L = document.createElement('canvas'); L.width = S; L.height = H;
    return { S: S, H: H, gx: gx, gy: gy, med: med, fine: fine, amt: S / 900 * 1.8, layer: L };
  }

  // Calque texte a la taille de la photo (transparent hors des lettres)
  function renderLayer(){
    var c = flockCfg, f = FX, S = f.S, H = f.H, tx = flockTexts();
    var box = [S, H, 0, 0]; // zone utile, pour ne traiter que les pixels des lettres
    function alphaOf(stroke){
      var cv = document.createElement('canvas'); cv.width = S; cv.height = H;
      var g = cv.getContext('2d', { willReadFrequently: true });
      g.textAlign = 'center'; g.textBaseline = 'alphabetic'; g.lineJoin = 'round';
      g.fillStyle = '#fff'; g.strokeStyle = '#fff';
      function put(t, ghost, xc, yc, capH, spec, maxW, outline, al){
        if(!t) return;
        g.textAlign = al === 'r' ? 'right' : al === 'l' ? 'left' : 'center';
        g.font = fontStr(spec, 100);
        var asc = g.measureText('H').actualBoundingBoxAscent || 72;
        var fs = 100 * capH / asc;
        g.font = fontStr(spec, fs);
        var tw = g.measureText(t).width, sx = 1;
        // Trop large : comme un vrai flocage, on serre d'abord les lettres (jusqu'a 70 % de leur largeur,
        // hauteur intacte), et on ne reduit la hauteur qu'au-dela.
        if(maxW && tw > maxW){
          sx = maxW / tw;
          if(sx < 0.7){ var r = sx / 0.7; fs *= r; capH *= r; sx = 0.7; g.font = fontStr(spec, fs); }
          tw = maxW;
        }
        var yy = yc + capH / 2;
        g.globalAlpha = ghost ? 0.45 : 1;
        g.save(); g.translate(xc, yy); g.scale(sx, 1);
        if(stroke){ g.lineWidth = fs * 0.1; g.strokeText(t, 0, 0); g.fillText(t, 0, 0); }
        else if(outline){ g.lineWidth = fs * 0.06; g.strokeText(t, 0, 0); }
        else { g.fillText(t, 0, 0); }
        g.restore();
        var pad = fs * 0.15 + 6;
        var lx = al === 'r' ? xc - tw : al === 'l' ? xc : xc - tw / 2;
        box[0] = Math.min(box[0], lx - pad); box[2] = Math.max(box[2], lx + tw + pad);
        box[1] = Math.min(box[1], yy - capH - pad);   box[3] = Math.max(box[3], yy + pad);
      }
      // Nom long : on le resserre a ~70 % du dos (largeur des noms officiels, ex. BACHIRA), sinon il touche les coutures
      // nw = largeur max propre au maillot (Bastard : le nom est pris entre les bandes dorees de l'empiecement)
      if(hasName){ put(tx.name, tx.nameGhost, c.x * S, c.name.y * H, c.name.h * H, c.nf, c.nw ? c.nw * S : c.w * S * 0.7, false); }
      // Largeur max : un "99" ne doit pas deborder du dos ni recouvrir l'ecusson sur la poitrine
      put(tx.num, tx.numGhost, c.x * S, c.num.y * H, c.num.h * H, c.mf, c.w * S * (isJersey ? 0.72 : 0.9), !!c.num.outline, c.num.al);
      if(c.front && isJersey){ put(tx.num, tx.numGhost, c.front.x * S, c.front.y * H, c.front.h * H, c.mf, c.front.mw ? c.front.mw * S : c.w * S * 0.4, false); }
      var d = g.getImageData(0, 0, S, H).data, a = new Float32Array(S * H);
      for(var i = 0; i < a.length; i++){ a[i] = d[i * 4 + 3] / 255; }
      return a;
    }
    var fa = alphaOf(false), sa = c.stroke ? alphaOf(true) : null;
    var x0 = Math.max(0, box[0] | 0), y0 = Math.max(0, box[1] | 0), x1 = Math.min(S - 1, Math.ceil(box[2])), y1 = Math.min(H - 1, Math.ceil(box[3]));
    var i, x, y, sum = 0, cnt = 0;
    for(y = y0; y <= y1; y++){ for(x = x0; x <= x1; x++){ i = y * S + x; if(fa[i] > 0.3){ sum += f.med[i]; cnt++; } } }
    var mean = cnt ? sum / cnt : 128;
    var fc = hexRgb(c.fill), sc = c.stroke ? hexRgb(c.stroke) : null;
    var lg = f.layer.getContext('2d');
    lg.clearRect(0, 0, S, H);
    if(x1 <= x0 || y1 <= y0) return f.layer;
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1, out = lg.createImageData(bw, bh), o = out.data;
    function samp(arr, sx, sy){ // bilineaire
      if(sx < 0 || sy < 0 || sx > S - 1 || sy > H - 1) return 0;
      var xa = sx | 0, ya = sy | 0, xb = Math.min(S - 1, xa + 1), yb = Math.min(H - 1, ya + 1), u = sx - xa, v = sy - ya;
      return (arr[ya*S+xa]*(1-u) + arr[ya*S+xb]*u)*(1-v) + (arr[yb*S+xa]*(1-u) + arr[yb*S+xb]*u)*v;
    }
    for(y = y0; y <= y1; y++){
      for(x = x0; x <= x1; x++){
        i = y * S + x;
        var sx = x - f.gx[i] * f.amt, sy = y - f.gy[i] * f.amt;
        var A = samp(fa, sx, sy), B = sa ? samp(sa, sx, sy) : 0, al = Math.max(A, B);
        if(al <= 0.003) continue;
        var sh = Math.max(0.72, Math.min(1.15, f.med[i] / Math.max(mean, 1))), gr = f.fine[i] * 0.12;
        var r = fc[0], gg = fc[1], bb = fc[2];
        if(sc && B > A){ var k = A / Math.max(B, 1e-3); r = fc[0]*k + sc[0]*(1-k); gg = fc[1]*k + sc[1]*(1-k); bb = fc[2]*k + sc[2]*(1-k); }
        var j = ((y - y0) * bw + (x - x0)) * 4;
        o[j]   = Math.max(0, Math.min(255, r * sh + gr));
        o[j+1] = Math.max(0, Math.min(255, gg * sh + gr));
        o[j+2] = Math.max(0, Math.min(255, bb * sh + gr));
        o[j+3] = Math.round(al * 0.97 * 255);
      }
    }
    lg.putImageData(out, x0, y0);
    return f.layer;
  }

  // Calque pose sur l'image principale
  var flockEl = document.querySelector('[data-flock]');
  var flockCanvas = flockEl ? flockEl.querySelector('[data-flock-canvas]') : null;
  function placeFlock(){
    if(!flockEl) return;
    var active = document.querySelector('.product-bl__image.active');
    var k = active ? flockKey(active.currentSrc || active.getAttribute('src')) : null;
    if(!FX || !toggle.checked || isBlank() || !k || !active.complete || !active.naturalWidth){ flockEl.hidden = true; return; }
    var wrap = flockEl.parentNode.getBoundingClientRect(), r = active.getBoundingClientRect();
    var sc = Math.min(r.width / FX.S, r.height / FX.H);
    flockEl.hidden = false;
    flockCanvas.style.left = (r.left - wrap.left + (r.width - FX.S * sc) / 2) + 'px';
    flockCanvas.style.top = (r.top - wrap.top + (r.height - FX.H * sc) / 2) + 'px';
    flockCanvas.style.width = (FX.S * sc) + 'px';
    flockCanvas.style.height = (FX.H * sc) + 'px';
  }
  var imgWrap = flockEl ? flockEl.parentNode : null;
  if(imgWrap){
    new MutationObserver(function(muts){
      for(var i = 0; i < muts.length; i++){ if(!flockEl.contains(muts[i].target)){ setTimeout(placeFlock, 0); return; } }
    }).observe(imgWrap, { attributes: true, attributeFilter: ['class', 'src'], subtree: true });
    imgWrap.addEventListener('load', function(){ placeFlock(); }, true);
    window.addEventListener('resize', placeFlock);
  }
  toggle.addEventListener('change', function(){ setTimeout(placeFlock, 120); });
  if(blankBox){ blankBox.addEventListener('change', placeFlock); }

  // Chargement paresseux (polices + photo en CORS) a la 1re ouverture de la personnalisation
  var fxStarted = false, fxFailed = false;
  function startFX(){
    if(fxStarted || !flockSrc) return;
    fxStarted = true;
    var specs = [flockCfg.mf]; if(flockCfg.nf) specs.push(flockCfg.nf);
    // Les polices : on attend au plus 3 s pour le 1er rendu, et on refait le rendu des qu'elles arrivent.
    var fontsLoaded = new Promise(function(res){
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = FONTS_CSS;
      l.onload = function(){
        if(!document.fonts || !document.fonts.load){ res(); return; }
        Promise.all(specs.map(function(s){ return document.fonts.load(fontStr(s, 60), '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'); })).then(res, res);
      };
      l.onerror = res;
      document.head.appendChild(l);
    });
    var fontReady = Promise.race([fontsLoaded, new Promise(function(r){ setTimeout(r, 3000); })]);
    fontsLoaded.then(function(){ if(FX) env.redraw(); });
    // URL distincte de celle de la galerie : sinon Chrome peut resservir la copie chargee sans CORS
    // (clic sur la vignette Customized = la galerie charge la meme photo au meme instant) et le canvas est bloque.
    function loadImg(tag){
      return new Promise(function(res){
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function(){ res(im); }; im.onerror = function(){ res(null); };
        im.src = flockSrc + (flockSrc.indexOf('?') < 0 ? '?' : '&') + 'blfx=' + tag;
      });
    }
    function attempt(tag, left){
      Promise.all([fontReady, loadImg(tag)]).then(function(r){
        var im = r[1];
        if(im && im.naturalWidth){ flockImg = im; FX = prepFX(); }
        if(FX){ env.redraw(); return; }
        if(left > 0){ setTimeout(function(){ attempt(tag + 1, left - 1); }, 800); }
        else { fxFailed = true; env.redraw(); } // echec definitif : l'ancien apercu reprend la main
      });
    }
    attempt(1, 2);
    if(DOS[flockKeyName] && env.assetBase){
      var di = new Image();
      di.onload = function(){ dosImg = di; if(FX) env.redraw(); };
      di.src = env.assetBase + 'bl-dos-' + flockKeyName + '.jpg?v=2026102103';
    }
  }
  toggle.addEventListener('change', function(){ if(toggle.checked) startFX(); });
  if(toggle.checked) startFX();

  var previewNote = block.querySelector('[data-custom-note]');
  var drawPending = false;
  function drawPhotoPreview(){
    var L = renderLayer(), f = FX, c = flockCfg, im = flockImg;
    if(flockCanvas){
      if(flockCanvas.width !== f.S){ flockCanvas.width = f.S; flockCanvas.height = f.H; }
      var fg = flockCanvas.getContext('2d'); fg.clearRect(0, 0, f.S, f.H); fg.drawImage(L, 0, 0);
      placeFlock();
    }
    // Cadre "Apercu" : le dos seul sur fond blanc (image detouree assets/bl-dos-<cle>.jpg), flocage par-dessus
    var ctx = canvas.getContext('2d'), w = canvas.width, h = canvas.height, S = f.S;
    var box = DOS[flockKeyName];
    if(box && dosImg && dosImg.naturalWidth){
      var bx = box[0] * S, by = box[1] * f.H, bw = (box[2] - box[0]) * S, bh = (box[3] - box[1]) * f.H;
      var k = Math.min(w / bw, h / bh) * 0.96, dw = bw * k, dh = bh * k, dx = (w - dw) / 2, dy = (h - dh) / 2;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(dosImg, dx, dy, dw, dh);
      ctx.drawImage(L, bx, by, bw, bh, dx, dy, dw, dh);
      return;
    }
    var cropW = c.w * 1.75 * S, cropH = cropW * h / w;
    var cy = ((hasName ? c.name.y : c.num.y - c.num.h) + c.num.y) / 2 * f.H + cropH * 0.06;
    var sx = Math.max(0, Math.min(S - cropW, c.x * S - cropW / 2));
    var sy = Math.max(0, Math.min(f.H - cropH, cy - cropH / 2));
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(im, sx, sy, cropW, cropH, 0, 0, w, h);
    ctx.drawImage(L, sx, sy, cropW, cropH, 0, 0, w, h);
  }

  return {
    draw: function(){
      // La case peut etre cochee sans evenement "change" (clic sur la vignette Customized, ?variant= dans l'URL)
      if(toggle.checked) startFX();
      var photo = !!FX;
      canvas.classList.toggle('is-photo', photo);
      if(previewNote) previewNote.hidden = !photo;
      if(photo){
        if(!drawPending){ drawPending = true; setTimeout(function(){ drawPending = false; drawPhotoPreview(); }, 16); }
        return true;
      }
      if(flockEl) flockEl.hidden = true;
      if(flockSrc && !fxFailed){
        // Photo calee en cours de chargement (~1-2 s) : fond clair plutot que l'ancien rectangle noir
        canvas.classList.add('is-photo');
        var g = canvas.getContext('2d');
        g.fillStyle = '#fff'; g.fillRect(0, 0, canvas.width, canvas.height);
        return true;
      }
      return false;
    }
  };
};
